import React from "react";
import { createPortal } from "react-dom";

// Render children into document.body so overlays/modals escape any
// ancestor stacking context (transforms/filters/etc.)
export default function Portal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}
